// El logo de la empresa.
//
// ── Dónde va, y por qué ahí ──
//
// En los PAPELES: la relación, el comprobante de egreso y la remisión. Es donde
// un logo hace trabajo de verdad — el papel que recibe un finquero o un
// mayorista tiene que verse salido de una empresa, no de un programa. Y en el
// menú, para que quien entra vea la suya y no un emoji.
//
// No va en la pantalla de entrar: ahí todavía no se sabe de qué empresa es
// quien está llegando, y poner el de uno en la puerta de todos sería enseñarle
// a un cliente el logo de otro.
//
// ── Por qué se guarda dentro de la base y no como archivo ──
//
// Un logo pesa poco y se mira en cada papel. Guardado como archivo suelto hay
// que servirlo, respaldarlo aparte y acordarse de copiarlo al mudar el
// servidor — y el día que falte, los papeles salen con un hueco. Dentro de la
// base viaja con todo lo demás.
//
// A cambio hay que ACHICARLO antes de guardar: la foto que sale de un teléfono
// pesa tres megas, y eso sí no cabe en un renglón que se lee en cada pantalla.

export const TIPOS = ['image/png', 'image/jpeg', 'image/webp'];

// El lado más largo al que se reduce. 400 px sobra para un encabezado impreso
// —a 300 puntos por pulgada son más de tres centímetros— y deja el archivo en
// unas decenas de kilobytes.
export const LADO_MAXIMO = 400;

// Lo que se acepta guardar ya convertido. Un logo bien achicado no llega ni a
// la mitad; pasarse de aquí es señal de que la reducción no ocurrió.
export const MAXIMO_BYTES = 300 * 1024;

// Qué le pasa a este archivo, dicho en palabras. Devuelve null si está bien.
export function revisarArchivo(archivo) {
  if (!archivo) return 'No se escogió ningún archivo.';
  if (!TIPOS.includes(archivo.type)) {
    return 'El logo tiene que ser una imagen PNG, JPG o WEBP. ' +
           'Un PDF o un documento de Word no sirven.';
  }
  // El tope de ENTRADA es generoso porque la foto se va a achicar aquí mismo.
  // Rechazar una foto de teléfono por pesada obligaría a editarla afuera, que
  // es justo lo que esta pantalla viene a evitar.
  if (archivo.size > 12 * 1024 * 1024) {
    return 'Esa imagen pesa más de 12 MB. Mándela más pequeña.';
  }
  return null;
}

// A qué tamaño se reduce, guardando la proporción.
//
// Nunca se AGRANDA: un logo de 80 px estirado a 400 se ve peor impreso que
// pequeño y nítido.
export function medidasDestino(ancho, alto, lado = LADO_MAXIMO) {
  const a = Number(ancho), b = Number(alto);
  if (!Number.isFinite(a) || !Number.isFinite(b) || a <= 0 || b <= 0) return null;
  const mayor = Math.max(a, b);
  if (mayor <= lado) return { ancho: Math.round(a), alto: Math.round(b) };
  const factor = lado / mayor;
  return {
    // Al menos 1 px: una imagen larguísima y finísima no puede quedar en cero.
    ancho: Math.max(1, Math.round(a * factor)),
    alto: Math.max(1, Math.round(b * factor)),
  };
}

// Cuánto pesa de verdad un data URI, que no es lo que mide la cadena.
//
// El base64 usa cuatro letras por cada tres bytes, y las que sobran se rellenan
// con «=». Sin descontarlas, el peso sale un tercio más alto y se rechazarían
// logos que sí caben.
export function pesoDe(dataUri) {
  const s = String(dataUri || '');
  const coma = s.indexOf(',');
  if (coma < 0) return 0;
  const cuerpo = s.slice(coma + 1);
  const relleno = (cuerpo.endsWith('==') ? 2 : cuerpo.endsWith('=') ? 1 : 0);
  return Math.max(0, Math.floor(cuerpo.length * 3 / 4) - relleno);
}

export function esImagenValida(dataUri) {
  return /^data:image\/(png|jpeg|webp);base64,/.test(String(dataUri || ''));
}
